import axios from 'axios';
import config from '../Config';
import authHeader from './auth-header';

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;

const getPackingSlipDropdown = (page, pagesize, search, groupId, ordering) => {
    return axios.get(API_URL + '/api/' + API_VERSION + '/dispatch-verification/get-slip-numbers/', {
        headers: authHeader(),
        params: {
            page: page,
            pagesize: pagesize,
            search: search,
            die_group: groupId,
            ordering: ordering,
        },
    });
};

const verifyPackingSlip = (page, pagesize, search, groupId, ordering, slip_no) => {
    return axios.get(`${API_URL}/api/${API_VERSION}/dispatch-verification/get-bundles-by-slip/?slip_no=${slip_no}`, {
        headers: authHeader(),
        params: {
            page: page,
            pagesize: pagesize,
            search: search,
            die_group: groupId,
            ordering: ordering,
        },
    });
};
const dispatchVerificationListService = {
    getPackingSlipDropdown,
    verifyPackingSlip,
};

export default dispatchVerificationListService;
